<template>
  <div>
    <div class="invoices__filter" v-if="invoices.length > 0">
      <div class="invoices__filter-label">Jahr</div>
      <select class="invoices__year" ref="year" @change.stop="yearSelected">
        <option v-for="year in years" :value="year" :key="year">
          {{ year }}
        </option>
      </select>
    </div>

    <template v-if="invoices.length > 0">
      <div class="invoice" v-for="invoice in invoices" :key="invoice.name">
        <div class="invoice__label">
          {{ formatDate(invoice.date) }}
        </div>
        <a :href="invoice.url" class="invoice__link" target="_blank">
          {{ invoice.name }}
          <IconExternal />
        </a>
      </div>
    </template>
    <div class="invoices__empty" v-else>
      {{ str('settings.noInvoices') }}
    </div>
  </div>
</template>

<script>
  import util from '@/js/Util'
  import IconExternal from '@/components/icons/External'

  export default {
    name: 'invoices',
    components: {
      IconExternal,
    },
    computed: {
      years: function () {
        return this.$store.getters.invoiceYears
      },
      invoices: function () {
        return this.$store.getters.invoicesOfYear()
      },
    },
    methods: {
      yearSelected: function (event) {
        const year = parseInt(event.target.value, 10)
        this.$store.dispatch('selectInvoiceYear', year)
      },
      formatDate: function (date) {
        return util.formatDate(date)
      },
    },
  }
</script>

<style lang="scss">
  .invoices {
    &__filter {
      margin-bottom: spacer(2);

      &-label {
        display: inline-block;
        line-height: 2rem;
        margin-right: spacer(1);
      }
    }
  }

  .invoice {
    margin-top: spacer(1);

    @media (min-width: $bp-sm) {
      display: flex;
      margin-top: spacer(0.5);
    }

    &__label {
      line-height: $line-height-sm;
      color: $grey-dark;
      flex-basis: 25%;

      @media (min-width: $bp-sm) {
        font-size: $font-size-lg;
        line-height: $line-height-base;
      }
    }

    &__link {
      font-size: $font-size-lg;
      color: $body-color;
      transition: $transition-base;

      .icon {
        width: 1em;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
</style>
